import { InMemoryCache } from 'apollo-cache-inmemory';
import UserSession from '../service/UserSession';
import { message } from 'antd';
import { myFetchImplementation } from '../service/EncryptRequest';
import { history } from '../store';

const isQueryEncrypted = true;

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
}

const config = {
  uri: process.env.REACT_APP_API_HOST,
  cache: new InMemoryCache(),
  defaultOptions: defaultOptions,
  connectToDevTools: true,
  request: (operation) => {
    const token = UserSession.getToken();
    operation.setContext({
      headers: {
        authorization: token ? `Bearer ${token}` : ''
      }
    })
  },
  onError: ({ graphQLErrors, networkError }) => {
    console.log('graphql error:', graphQLErrors,networkError);
    // message.destroy();
    // let messageFun = message;
    // if (graphQLErrors) {
    //   if( (graphQLErrors[0].extensions || {}).code === 500 ) {
    //      // messageFun.error(`${graphQLErrors[0].message}`);
    //     // history.push({pathname: '/error', query: { message: graphQLErrors[0].message }});
    //   } else if (graphQLErrors[0] && !graphQLErrors[0].message.includes('401') && !(graphQLErrors[0].extensions || {}).code === 401) {
    //    //  messageFun.error(`${graphQLErrors[0].message}`);
    //   }else if (graphQLErrors[0] && (graphQLErrors[0].extensions || {}).code === 400) {
    //    //  messageFun.error(`${graphQLErrors[0].message}`);
    //   } else {
    //     UserSession.clearSession();
    //     history.push('/');
    //   }
    // }

    // if (networkError && networkError.code === 401) {
    //   UserSession.clearSession()
    //   history.push('/');
    // } else if (networkError) {
    //   messageFun.error((networkError.message || `Something went wrong!`));
    // }
  }
}

// if (isQueryEncrypted) {
//   config.fetch = myFetchImplementation;
// }

export default config;